export const environment = {
    production: true,
    apiCheckout: 'https://apigateway-ext.labchecap.com.br/checkout-externo/api/v1/',
    apiManifest: 'https://apigateway-ext.labchecap.com.br/ingenium/api/',
    apiNotaFiscal: 'https://apigateway-ext.labchecap.com.br/notafiscal/api/',
    apiAuthenticate: 'https://apigateway-ext.labchecap.com.br/identidade-aplicacao/api/',
    apikeyCheckout: '23131D570B1D1C1E501F2D0D050F06770D00414E37102D1859134B34282D3C2D22E22626250B23351A27',
    apikeyManifestacao: '794B15570B181314031F2E05530C75010601414E37102D185913502024272B3B2FE72D2928263E391B3338FE23233C33393B1F1C2CF02B2E',
    siteKeyCaptcha: '6Lf9jeopAAAAAJQqqQjQtveGbz-FrWQfseP-ORcy'
};
